/**
 * @module byo-bundle/state
 * Pure slot state: one selected variant ID (or null) per slot.
 */

export type Slots = Array<number | null>;

export function createSlots(count: number): Slots {
  return Array.from({ length: count }, () => null);
}

export function selectVariant(slots: Slots, index: number, variantId: number): Slots {
  return slots.map((current, i) => (i === index ? variantId : current));
}

export function removeVariant(slots: Slots, index: number): Slots {
  return slots.map((current, i) => (i === index ? null : current));
}

export function filledCount(slots: Slots) {
  return slots.filter((id) => id !== null).length;
}

export function isComplete(slots: Slots) {
  return slots.length > 0 && filledCount(slots) === slots.length;
}
